import { render, staticRenderFns } from "./candidate.vue?vue&type=template&id=29b835f2&scoped=true&"
import script from "./candidate.vue?vue&type=script&lang=js&"
export * from "./candidate.vue?vue&type=script&lang=js&"
import style0 from "./candidate.vue?vue&type=style&index=0&id=29b835f2&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29b835f2",
  null
  
)

export default component.exports